<template>
  <div class="generic-button"
       :class="classes"
       @click="onClickHandler">
    <slot>Click</slot>
  </div>
</template>
<script>

export default {
  name: "GenericButton",
  props: {
    loc: {
      type: String,
      required: true,
    },
    classes: {
      type: String,
      default: "cta cta--primary--alt",
    },
  },
  methods: {
    onClickHandler () {
      window.location.href = this.loc;
    },
  },
};
</script>
